import React, { useEffect, useState } from "react"
import "./style.css"

import logo from "../../../assets/images/logocarterinha.png"
import userDefault from "../../../assets/images/user.png"
import ass from "../../../assets/images/ass.png"
import api from "../../../Services/api"
import Url_Image from "../../../assets/URL'S/Url_Image"

export default function CarterinhaMobile() {
  const locale = "pt-BR"
  const [user, setUser] = useState("")
  const [alunoData, setAlunoData] = useState([])

  let imageUrl = ""

  useEffect(() => {
    const token = localStorage.getItem("token")
    async function getDataUser() {
      api
        .get("/aluno/perfil", token)
        .then(async (response) => {
          setAlunoData(response.data)
          imageUrl = await Url_Image(response.data.rm)
          setUser(imageUrl)
          try {
            const response = await fetch(imageUrl)
            if (!response.ok) {
              setUser("undefined")
            }
            const blob = await response.blob()
            const url = URL.createObjectURL(blob)
            setUser(url)
          } catch (error) {
            setUser("undefined")
            console.error(error)
          }
        })
        .catch((err) => {
          setUser("undefined")
          console.log(err)
        })
    }
    getDataUser()
  }, [])
  return (
    <div className="globalMobile">
      <div className="circleMobile" style={{ backgroundColor: alunoData.cor_convenio }}></div>
      <div className="quadrosMobile">
        <img src={user == "undefined" || !user ? userDefault : user} alt="perfil" className="perfilfotoMobile" />
      </div>
      <div className="infocardMobile">
        <h1 className="namesMobile">{alunoData.nome_aluno}</h1>
        <div className="cardsssMobile">
          <div className="columnsMobile">
            <p>RM</p>
            <p style={{ fontWeight: 700 }}>{alunoData.rm}</p>
          </div>
          <div className="columnsMobileC" >
            <p>Curso</p>
            <p className="nomeCursoMobile">
              {alunoData.nome_curso}
            </p>
          </div>
          <div className="columnsMobile">
            <p>Validade</p>
            <p style={{ color: "red", fontWeight: "700" }}>
              {new Date(alunoData.dt_termino).toLocaleDateString(locale)}
            </p>
          </div>
        </div>
      </div>
      <div className="imgamesMobile" >
        <img src={logo} alt="logo" className="logofiec" />
        <img src={ass} alt="assinatura" className="assinatura" />
      </div>
      <div className="logonameMobile">
        <p style={{ fontWeight: "600" }}>Prefeitura Municipal De Indaiatuba</p>
      </div>
      <p className="paragrafosMobile" >
        Este cartão é de uso estritamente pessoal e intransferível. O acesso a escola somente será permitido mediante
        apresentação desse cartão ou autorização da secretaria.
      </p>
      <div className="convenioMobile" style={{ backgroundColor: alunoData.cor_convenio }}>
        <p className="expoMobile">{alunoData.convenio}</p>
      </div>
    </div>
  )
}
